<template>
    <div class="barca2526">
        <page-navigate></page-navigate>
        <div class="rem-container cn">
            <section class="section1">
                <div class="section1-inner">
                    <!-- <img class="img-logo" src="../assets/image/logo/logo_row_white.svg" alt="logo" /> -->
                    <h1>
                        交易赢巴萨球票<br />
                        亲临<span>巴萨</span>25/26赛季主场
                    </h1>

                    <div class="title-intro">
                        在全球最佳券商EBC交易，即可赢取巴塞罗那足球俱乐部主场球票，机票、酒店全程礼遇，见证红蓝军团在绿茵场上的精彩演绎。
                    </div>
                    <!-- <h1 v-html="$t('barca2526.交易赢巴萨球票')">
                    </h1>
                    <div class="title-intro">
                        {{ $t('barca2526.在全球最佳EBC交易') }}
                    </div> -->
                    <ebc-btn>{{ $t('barca2526.立即参与') }}</ebc-btn>
                </div>
            </section>
            <section class="section2">
                <div class="section2-inner rem-wrapper">
                    <div class="vector-box scroll-fade-up">
                        <span class="iconfont icon-Vector blue"></span>
                        活动一
                        <span class="iconfont icon-Vector red"></span>
                    </div>
                    <h2 class="section2-title scroll-fade-up">
                        {{ $t('barca2526.达成交易目标') }}
                    </h2>
                    <p class="title-intro scroll-fade-up">
                        {{ $t('barca2526.在活动期间完成指定净入金与交易量') }}
                    </p>
                    <div class="link-box scroll-fade-up">
                        <a href="javascript:;" @click="myDialogShow()" class="show-link">{{ $t('barca2526.查看赛程')
                        }}</a>
                    </div>


                    <div class="section2-content">
                        <swiper class="swiper-container good-list" :options="swiperOptions">
                            <swiper-slide>
                                <div class="level-box">
                                    <div class="level-title" v-html="$t('barca2526.*净入金达到20,000 USD')"></div>
                                    <div class="level-content">
                                        <div class="level-item">
                                            <img class="level-img"
                                                src="../assets/image/activity/barac2526/level6-11.png" alt="" />
                                            <p class="level-tips" v-html="$t('barca2526.巴塞罗那足球俱乐部普通球票×1')">

                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="level-box">
                                    <div class="level-title" v-html="$t('barca2526.*净入金达到 40,000 USD')"></div>
                                    <div class="level-content">
                                        <div class="level-item">
                                            <img class="level-img" src="../assets/image/activity/barac2526/level6-1.png"
                                                alt="" />
                                            <p class="level-tips" v-html="$t('barca2526.巴塞罗那足球俱乐部普通球票×2')">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="level-box">
                                    <div class="level-title" v-html="$t('barca2526.*净入金达到 50,000 USD')"></div>
                                    <div class="level-content">
                                        <div class="level-item">
                                            <img class="level-img"
                                                src="../assets/image/activity/barac2526/level6-11.png" alt="" />
                                            <p class="level-tips" v-html="$t('barca2526.巴塞罗那足球俱乐部VIP球票×1')">

                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="level-box">
                                    <div class="level-title" v-html="$t('barca2526.*净入金达到100,000 USD')"></div>
                                    <div class="level-content">
                                        <div class="level-item">
                                            <img class="level-img" src="../assets/image/activity/barac2526/level6-1.png"
                                                alt="" />
                                            <p class="level-tips" v-html="$t('barca2526.巴塞罗那足球俱乐部VIP球票×2')">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="level-box">
                                    <div class="level-title" v-html="$t('barca2526.*净入金达到 300,000 USD')">

                                    </div>
                                    <div class="level-content">
                                        <div class="level-item">
                                            <img class="level-img"
                                                src="../assets/image/activity/barac2526/level6-11.png" alt="" />
                                            <p class="level-tips" v-html="$t('barca2526.巴塞罗那足球俱乐部尊享球票×1')">

                                            </p>
                                        </div>
                                        <span class="iconfont icon-right-round pc"></span>
                                        <div class="level-item">
                                            <img class="level-img"
                                                src="../assets/image/activity/barac2526/level6-21.png" alt="" />
                                            <p class="level-tips">{{ $t('barca2526.往返机票×1') }}</p>
                                        </div>
                                        <span class="iconfont icon-right-round pc"></span>
                                        <div class="level-item">
                                            <img class="level-img" src="../assets/image/activity/barac2526/level6-3.png"
                                                alt="" />
                                            <p class="level-tips">{{ $t('barca2526.住宿×3晚') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="level-box">
                                    <div class="level-title" v-html="$t('barca2526.*净入金达到 550,000 USD')">

                                    </div>
                                    <div class="level-content">
                                        <div class="level-item">
                                            <img class="level-img" src="../assets/image/activity/barac2526/level6-1.png"
                                                alt="" />
                                            <p class="level-tips" v-html="$t('barca2526.巴塞罗那足球俱乐部尊享球票×2')">
                                            </p>
                                        </div>
                                        <span class="iconfont icon-right-round pc"></span>
                                        <div class="level-item">
                                            <img class="level-img" src="../assets/image/activity/barac2526/level6-2.png"
                                                alt="" />
                                            <p class="level-tips">{{ $t('barca2526.往返机票×2') }}</p>
                                        </div>
                                        <span class="iconfont icon-right-round pc"></span>
                                        <div class="level-item">
                                            <img class="level-img" src="../assets/image/activity/barac2526/level6-3.png"
                                                alt="" />
                                            <p class="level-tips">{{ $t('barca2526.双人房住宿×3晚') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>

                        </swiper>
                        <!-- Add Pagination -->
                        <div class="good-list-swiper-pagination"></div>

                    </div>
                    <div class="section2-tips">
                        {{ $t('barca2526.为确保活动的公平与顺利进行') }}
                    </div>
                </div>
            </section>

            <section class="section3">
                <div class="section3-inner rem-wrapper">
                    <div class="vector-box scroll-fade-up">
                        <span class="iconfont icon-Vector blue"></span>
                        活动二
                        <span class="iconfont icon-Vector red"></span>
                    </div>
                    <h2 class="section3-title scroll-fade-up">{{ $t('barca2526.IB推荐好友') }}</h2>
                    <p class="title-intro scroll-fade-up">
                        {{ $t('barca2526.活动期间') }}
                    </p>
                    <div class="section3-content">
                        <div class="section3-content-card">
                            <div class="section3-content-table">
                                <div class="section3-content-table-item section3-content-table-item1">
                                    <h3 class="good-name has-icon">{{ $t('barca2526.尊享球票×1') }}</h3>
                                    <img class="img1" src="../assets/image/activity/barac2526/img1.png" alt="" />
                                </div>
                                <div class="section3-content-table-item section3-content-table-item2">
                                    <h3 class="good-name">{{ $t('barca2526.往返机票×1') }}</h3>
                                    <img class="img2" src="../assets/image/activity/barac2526/img2.png" alt="" />
                                </div>
                                <div class="section3-content-table-item section3-content-table-item3">
                                    <h3 class="good-name">{{ $t('barca2526.住宿×3晚') }}</h3>
                                    <img class="img3" src="../assets/image/activity/barac2526/img3.png" alt="" />
                                </div>
                            </div>
                            <p class="section3-number">88</p>
                            <p class="section3-number-label has-icon">{{ $t('barca2526.推荐人数') }}</p>
                        </div>
                        <div class="section3-content-card">
                            <div class="section3-content-table">
                                <div class="section3-content-table-item section3-content-table-item1">
                                    <h3 class="good-name has-icon">{{ $t('barca2526.尊享球票×2') }}</h3>
                                    <img class="img1" src="../assets/image/activity/barac2526/img12.png" alt="" />
                                </div>
                                <div class="section3-content-table-item section3-content-table-item2">
                                    <h3 class="good-name">{{ $t('barca2526.往返机票×2') }}</h3>
                                    <img class="img22" src="../assets/image/activity/barac2526/img22.png" alt="" />
                                </div>
                                <div class="section3-content-table-item section3-content-table-item3">
                                    <h3 class="good-name">{{ $t('barca2526.双人房住宿×3晚') }}</h3>
                                    <img class="img3" src="../assets/image/activity/barac2526/img3.png" alt="" />
                                </div>
                            </div>
                            <p class="section3-number">138</p>
                            <p class="section3-number-label has-icon">{{ $t('barca2526.推荐人数') }}</p>
                        </div>
                    </div>
                    <div class="section3-tips">
                        注册后一个月内，净入金累积达$500，计为达标日当月的有效客户，每位客户最多可计为1次有效客户，多账户也仅计一次。
                    </div>
                </div>
            </section>

            <section class="section4">
                <div class="section4-inner rem-wrapper">
                    <h2 class="section4-title scroll-fade-up">{{ $t('barca2526.如何获得奖励') }}</h2>
                    <div class="section4-content">
                        <div class="section4-card step1">
                            <img class="section4-img" src="../assets/image/activity/barac2526/step-img1.png" alt="" />
                            <p>{{ $t('barca2526.登录EBC用户中心') }}</p>
                        </div>
                        <span class="iconfont icon-right-round"></span>
                        <div class="section4-card step2">
                            <img class="section4-img" src="../assets/image/activity/barac2526/step-img2.png" alt="" />
                            <p>{{ $t('barca2526.完成交易') }}</p>
                        </div>
                        <span class="iconfont icon-right-round"></span>
                        <div class="section4-card step3">
                            <img class="section4-img" src="../assets/image/activity/barac2526/step-img3.png" alt="" />
                            <p>
                            填写表单，申请奖励
                            </p>
                        </div>
                    </div>
                    <div class="button-box">
                        <ebc-btn href="https://forms.office.com/r/DEEghHNyEW"> 填写表单，申请奖励</ebc-btn>
                    </div>
                </div>
            </section>

            <section class="section6">
                <div class="section6-inner rem-wrapper">
                    <h2 class="section6-title scroll-fade-up">“欧洲之花”——巴塞罗那</h2>
                    <div class="section6-content">
                        <div class="section6-content-left">
                            <swiper ref="attractionSwiper" class="swiper-container attraction-list"
                                :options="swiperAttractionOptions">
                                <swiper-slide>
                                    <h3 class="section6-item-title">地中海明珠</h3>
                                    <p class="section6-item-intro">
                                        踏上巴塞罗那，不仅能亲临世界顶级足球俱乐部——巴塞罗那的主场，现场感受热烈的比赛氛围，还能探索这座充满艺术气息的地中海之城。
                                    </p>
                                </swiper-slide>
                                <swiper-slide>
                                    <h3 class="section6-item-title">高迪之城</h3>
                                    <p class="section6-item-intro">
                                        这里是“神之建筑师”高迪的灵感殿堂。圣家堂以宏伟塔楼和精美雕刻成为城市地标；古埃尔公园的彩色马赛克与蜿蜒长椅宛如童话世界；巴特罗之家、米拉之家等建筑更将奇思妙想融入街头。
                                    </p>
                                </swiper-slide>
                                <swiper-slide>
                                    <h3 class="section6-item-title">宜居城市</h3>
                                    <p class="section6-item-intro">
                                        作为西班牙第二大城市和加泰罗尼亚的心脏，巴塞罗那兼具地中海的浪漫与现代都市的活力——阳光海岸、创意街头、丰富美食与夜生活，让人感受开放、包容又热情的城市氛围。
                                    </p>
                                </swiper-slide>
                            </swiper>

                            <div class="attraction-list-btns">
                                <div class="attraction-list-btn attraction-list-prev-btn" @click="prevImg">
                                    <span class="iconfont icon-wrapper1"></span>
                                </div>
                                <div class="attraction-list-btn attraction-list-next-btn" @click="nextImg">
                                    <span class="iconfont icon-wrapper1"></span>
                                </div>
                            </div>
                        </div>
                        <div ref="section6ContentRight" class="section6-content-right">
                            <div class="attraction-imgs" ref="attractionImgs">
                                <img src="../assets/image/activity/barac2526/attraction1.jpg" alt=""
                                    class="attraction-img" />
                                <img src="../assets/image/activity/barac2526/attraction2.jpg" alt=""
                                    class="attraction-img" />
                                <img src="../assets/image/activity/barac2526/attraction3.jpg" alt=""
                                    class="attraction-img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section5">
                <div class="section5-inner rem-wrapper">
                    <h2 class="section5-title scroll-fade-up">{{ $t('barca2526.活动须知') }}</h2>
                    <ebc-rule-list :rule-list="$t('barca2526.ruleList')"></ebc-rule-list>
                    <!-- <div class=" section5-tips">
                        {{ $t('barca2526.高风险交易产品披露') }}
                    </div> -->
                </div>
            </section>
        </div>

        <ebc-dialog ref="myDialog" :visible.sync="dialogVisiable">
            <div>
                <div class="match-list-box">
                    <div class="match-header" v-html="$t('barca2526.2025-26赛季巴塞罗那足球俱乐部联赛')">
                    </div>
                    <div class="match-list">
                        <div class="match-item" v-for="(item, index) in $t('barca2526.datelist')" :key="index">
                            <div class="match-item-label">
                                <p class="match-item-label-text">{{ item.date }}</p>
                            </div>
                            <div class="match-item-value">
                                <p class="match-item-value-text">
                                    {{ item.a }} <span class="match-vs">VS</span> {{ item.b }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="match-tips">
                    {{ $t('barca2526.本页联赛赛程仅表示主场比赛仅在该周末发生') }}

                </div>
            </div>
        </ebc-dialog>
        <page-footer></page-footer>
    </div>
</template>

<script>
import ebcRuleList from "../components/ebc-rule-list/ebc-rule-list.vue";
// 仅导入所需的组件
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import i18n from '@/i18n'
let levelList = i18n.t('barca2526.levelList');

export default {
    components: {
        "ebc-rule-list": ebcRuleList,
        Swiper,
        SwiperSlide
    }
    ,
    data() {
        return {
            swiperOptions: {
                spaceBetween: 25,
                // 自动播放设置
                autoplay: {
                    delay: 3000, // 3秒自动滚动
                    disableOnInteraction: false, // 用户操作后不取消自动播放
                },
                loop: true, // 无限循环
                initialSlide: 5, // 从第6个slide开始（索引为5）
                pagination: {
                    el: ".good-list-swiper-pagination",

                    clickable: true,
                    renderBullet: function (index, className) {
                        console.log("className", `${className}`);
                        return `
    <div class="good-index-item ${className}">
                <div class="good-index-box">
                  <span class="iconfont icon-stroke good-index-inner"></span>
                </div>
                <p class="Lv-label">${levelList[index].label}</p>
                <p class="Lv-value">${levelList[index].value}</p>
              </div>
      `;
                    },
                },
            },
            swiperAttractionOptions: {
                spaceBetween: 30,
                loop: true
            },
            currentIndex: undefined,
            fadeUpObserve: null,
            dialogVisiable: false,
            isMobile: false,
            currentIndex: 0,
            startX: 0,
            moveX: 0,
            isDragging: false,
        }
    },
    mounted() {
        
        // 初始化时检查一次
        this.checkScreenWidth();

        // 创建 IntersectionObserver
        this.fadeUpObserve = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('in-view');
                        // 动画触发后停止监听该元素
                        this.fadeUpObserve.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0, // 只要有一点进入视口就触发
                // 可选：rootMargin: '0px 0px -50px 0px' 提前触发
            }
        );

        // 开始观察所有 .scroll-fade-up 元素
        this.$nextTick(() => {
            const elements = this.$el.querySelectorAll('.scroll-fade-up');
            elements.forEach(el => this.fadeUpObserve.observe(el));
        });

        this.swiper = this.$refs.attractionSwiper.$swiper;
        this.swiper.on('slideChange', () => {
            this.currentIndex = this.swiper.realIndex;
            this.updateLayout();
        });


        // 使用节流后的函数绑定 resize 事件
        const throttledResize = this.throttle(this.checkScreenWidth, 200);
        window.addEventListener('resize', throttledResize);

        // ❗保存引用，以便销毁时移除
        this._throttledResize = throttledResize;

        // 触摸事件监听器
        this.$refs.section6ContentRight.addEventListener('touchstart', this.touchstart);
        this.$refs.section6ContentRight.addEventListener('touchmove', this.touchmove);
        document.addEventListener('touchend', this.touchend);
    },
    beforeDestroy() {
        if (this.fadeUpObserve) {
            this.fadeUpObserve.disconnect();
        }
        // 组件销毁前移除事件监听，防止内存泄漏
        if (this._throttledResize) {
            window.removeEventListener('resize', this._throttledResize);
        }
        this.$refs.section6ContentRight.removeEventListener('touchstart', this.touchstart);
        this.$refs.section6ContentRight.removeEventListener('touchmove', this.touchmove);
        document.removeEventListener('touchend', this.touchend);
    },
    methods: {
        myDialogShow(){
            this.$refs.myDialog.show();
        },
        prevImg() {
            this.swiper.slidePrev()
        },
        nextImg() {
            this.swiper.slideNext()
        },
        // 检测屏幕宽度
        checkScreenWidth() {
            const width = window.innerWidth;
            const wasMobile = this.isMobile;

            // 判断是否为移动端（小于 997px）
            this.isMobile = width < 997;

            // 可选：宽度变化后执行某些逻辑
            if (this.isMobile !== wasMobile) {
                console.log('设备类型变化:', this.isMobile ? '移动端' : 'PC端');
                // 例如：触发布局更新、重新初始化 Swiper 等
                // this.updateLayout();
            }
        },

        // 节流函数（可复用）
        throttle(fn, delay) {
            let ticking = false;
            return (...args) => {
                if (!ticking) {
                    requestAnimationFrame(() => {
                        fn.apply(this, args);
                        ticking = false;
                    });
                    ticking = true;
                }
            };
        },
        lidePrev() {
            this.swiper.slidePrev()
        },
        slideNext() {
            this.swiper.slideNext()
        },
        checkScreenWidth() {
            if (window.innerWidth < 996) {
                if (!this.isMobile) {
                    this.isMobile = true;
                    this.updateLayout();
                }
            } else {
                if (this.isMobile) {
                    this.isMobile = false;
                    this.updateLayout();
                }
            }
        },
        touchstart(e) {
            this.startX = e.touches[0].clientX;
            this.isDragging = true;
        },
        touchmove(e) {
            if (!this.isDragging) return;
            this.moveX = e.touches[0].clientX - this.startX;
        },
        touchend() {
            if (!this.isDragging) return;
            if (this.moveX > 50) this.swiper.slidePrev(); // 上一张
            else if (this.moveX < -50) this.swiper.slideNext(); // 下一张
            this.isDragging = false;
            this.startX = 0;
            this.moveX = 0;
        },
        // 更新布局
        updateLayout() {
            console.log("updateLayout", this.currentIndex)
            const attractionImgs = this.$refs.attractionImgs; // 获取所有 ref="attractionImg" 的元素
            console.log(imgs, "imgs")

            const imgs = Array.from(
                attractionImgs.querySelectorAll(".attraction-img")
            );

            if (!imgs || imgs.length === 0) return;

            imgs.forEach((img, index) => {
                const offset = (index - this.currentIndex + 3) % 3;

                if (this.isMobile) {
                    if (offset === 2) {
                        img.style.zIndex = 1;
                        img.style.transform = "translateX(0) scale(1)";
                        img.style.filter = "brightness(0.7)";
                    } else if (offset === 0) {
                        img.style.zIndex = 2;
                        img.style.transform = "translateX(33%) scale(1.25)";
                        img.style.filter = "brightness(1)";
                    } else if (offset === 1) {
                        img.style.zIndex = 1;
                        img.style.transform = "translateX(67%) scale(1)";
                        img.style.filter = "brightness(0.7)";
                    }
                } else {
                    if (offset === 0) {
                        img.style.zIndex = 3;
                        img.style.transform = "translateX(0) scale(1)";
                        img.style.filter = "brightness(1)";
                    } else if (offset === 1) {
                        img.style.zIndex = 2;
                        img.style.transform = "translateX(70rem) scale(0.9)";
                        img.style.filter = "brightness(0.7)";
                    } else if (offset === 2) {
                        img.style.zIndex = 1;
                        img.style.transform = "translateX(140rem) scale(0.8)";
                        img.style.filter = "brightness(0.5)";
                    }
                }
            });
        }
    }
}

</script>

<style lang="scss" scoped>
.barca2526 {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    /* 自动匹配用户系统默认字体 */
}

/* 显示滑入开始 */
.scroll-fade-up {
    transform: translateY(80rem);
    opacity: 0;
    transition: transform 0.6s ease-out, opacity 0.1s ease-out;
}

.in-view {
    transform: translate(0);
    opacity: 1;
}

.section1 {
    height: 722rem;
    background: url("../assets/image/activity/barac2526/bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.section1-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0 160rem;
    height: 100%;
    margin: 0 auto;
    max-width: 1920rem;
}

.ar .section1 {
    padding-right: 740rem;
}

.img-logo {
    height: 80rem;
}

.section1 h1 {
    //margin-top: 50rem;
    color: var(--ebc--, #fff);
    font-size: 64rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    max-width: 1000rem;
}

.en h1 {
    font-size: 56rem;
}

.jp h1 {
    font-size: 52rem;
}

.th h1 {
    font-size: 54rem;
}

.pt h1 {
    font-size: 48rem;
}

.ru h1 {
    font-size: 44rem;
}

.mn h1 {
    font-size: 54rem;
}

.id h1 {
    font-size: 54rem;
}

.kr h1 {
    font-size: 50rem;
}

.es h1 {
    font-size: 40rem;
}



.section1 .title-intro {
    margin-top: 22rem;
    color: var(--Text-Primary_White, #fff);
    font-size: 24rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 1000rem;
    text-align: start;
}

.en .title-intro {
    font-size: 18rem;
    font-weight: 400;
}

.section1 .ebc-btn-large {
    margin-top: 70rem;
    min-width: 270rem;
}

.rem-container h2 {
    color: var(--Text-Primary, #000);
    font-size: 48rem;
    font-style: normal;
    font-weight: 700;
    line-height: 56rem;
    text-align: center;
    padding: 0 20rem;
}

.section2-inner,
.section3-inner,
.section4-inner,
.section5-inner,
.section6-inner {
    padding: 120rem 360rem;
}

.title-intro {
    margin-top: 16rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    text-align: center;
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
}

.section2 {
    background: url("../assets/image/activity/barac2526/bg2.jpg");
    background-repeat: no-repeat;
    background-size: cover;
}

.section2 .link-box {
    margin-top: 16rem;
    display: flex;
    justify-content: center;
}

.section2 .vector-box,
.section3 .vector-box {
    margin-bottom: 16rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5rem;
    color: var(--Text-Primary, #000);
    text-align: center;
    font-size: 24rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5;
}

.section3 .vector-box {
    color: #fff;
}

.section2 .vector-box .icon-Vector,
.section3 .vector-box .icon-Vector {
    font-size: 18rem;
}

.section2 .vector-box .blue,
.section3 .vector-box .blue {
    color: #114291;
}

.section2 .vector-box .red,
.section3 .vector-box .red {
    color: #a52933;
}

.section2 .show-link {
    position: relative;
    display: flex;
    /* align-items: center; */
    gap: 6rem;
    color: var(--Brand-Secondary-Red, #a52933);
    text-align: center;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.75;
    /* text-decoration-line: underline; */
}

.section2 .show-link::after {
    content: "\e624";
    font-family: "iconfont" !important;
    font-size: 16rem;
    line-height: 1.75;
}

.section2-content {
    margin-top: 46rem;
    padding: 60rem 20rem;
    border-radius: var(--Corner-Radius-RC24, 24rem);
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(12rem);
    overflow: hidden;
}


.section3 {
    background: url("../assets/image/activity/barac2526/bg3.jpg");
    background-repeat: no-repeat;
    background-size: cover;
}

.section3 .section3-title {
    color: var(--Text-Primary_White, #fff);
}

.section3 .title-intro {
    color: var(--Text-Primary_White, #fff);
}

.section3-content {
    position: relative;
    display: flex;
    gap: 24rem;
    margin-top: 40rem;
    width: 100%;
    height: 478rem;
    background: url("../assets/image/activity/barac2526/section3_card.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.section3-content-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: calc(50% - 12rem);
    height: 100%;
    flex-shrink: 0;
}

.section3-content-card:first-child {
    padding-right: 16rem;
}

.section3-content-card:last-child {
    padding-left: 16rem;
}

.section3-content-table {
    display: grid;
    grid-template-columns: 230rem 230rem;
    /* 2列，等宽 */
    grid-template-rows: 125rem 125rem;
    /* 2行，等高 */
    gap: 16rem;
    /* 间距16px */
}

.en .section3-content-table {
    grid-template-rows: 145rem 145rem;
    /* 2行，等高 */
}

.section3-content-table-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20rem;
    border-radius: var(--Corner-Radius-RC08, 8rem);
    background: linear-gradient(180deg, #fff 0%, #fff 100%);
    gap: 8rem;
}

.pt .section3-content-table-item {
    padding: 8rem;
}

.pt .good-name {
    font-size: 16rem;
}

.section3-content-table-item1 {
    grid-column: 1;
    /* 第1列 */
    grid-row: 1 / span 2;
    /* 从第1行开始，跨越2行 */
}

.section3-content .good-name {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6rem;
    color: var(--Text-Primary, #000);
    text-align: center;
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.3;
}

.en .good-name {
    font-size: 18rem;
}

.section3-content .has-icon::before {
    font-family: "iconfont" !important;
    content: "\e605";
    color: #a52933;
}

.section3-content .has-icon::after {
    font-family: "iconfont" !important;
    content: "\e605";
    color: #114291;
}

.section3 .img1 {
    margin-top: 10rem;
    height: 180rem;
}

.section3 .img2 {
    height: 33rem;
}

.section3 .img22 {
    height: 42rem;
}

.section3 .img3 {
    height: 55rem;
}

.section3-number {
    margin-top: 20rem;
    color: var(--Text-Primary_White, #fff);
    text-align: center;
    font-size: 40rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.2;
}

.section3-number-label {
    display: flex;
    gap: 8rem;
    margin-top: 4rem;
    color: var(--Text-Primary_White, #fff);
    text-align: center;
    font-size: 24rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5;
    /* 150% */
}

.section4 {
    /* padding: 40rem 0; */
    // background: #f7f7f7;
}

.section6 {
    /* padding: 40rem 0; */
    background: #f7f7f7;
}

.section4-content {
    margin-top: 60rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.section4-card {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 18rem 16rem;
    height: 132rem;
    width: 362rem;
    border-radius: var(--Corner-Radius-RC16, 16rem);
    background: #f7f7f7;
    gap: 12rem;
}

.pt .section4-card {
    height: 180rem;
}

.section4-img {
    width: 94rem;
    height: 94rem;
    flex-shrink: 0;
}

.section4-card p {
    color: var(--Text-Primary, #000);
    /* text-align: center; */
    font-size: 24rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    /* 150% */
}

.en .section4-card p {
    font-size: 18rem;
}

.section4-form-btn {
    color: #a52933;
    text-decoration: underline;
}

.section4-form-btn:hover {
    color: #a52933;
}

.step1 {
    background-image: url("../assets/image/activity/creator-incentives/1.png");
    background-repeat: no-repeat;
    background-size: 120rem auto;
    background-position: right bottom;
}

.step2 {
    background-image: url("../assets/image/activity/creator-incentives/2.png");
    background-repeat: no-repeat;
    background-size: 120rem auto;
    background-position: right bottom;
}

.step3 {
    background-image: url("../assets/image/activity/creator-incentives/3.png");
    background-repeat: no-repeat;
    background-size: 120rem auto;
    background-position: right bottom;
}

.section4 .icon-right-round {
    font-size: 24rem;
    color: #595959;
}

.ar .section4 .icon-right-round {
    transform: rotate(180deg);
}

.button-box {
    margin-top: 60rem;
    display: flex;
    justify-content: center;
}

.section5-tips {
    margin-top: 40rem;
    color: var(--Text-Quaternary, rgba(0, 0, 0, 0.24));
    font-size: 12rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.6;
}

.match-list-box {
    /* background: #fff; */
    border-radius: 10rem;
    padding-bottom: 30rem;
}

.match-tips {
    color: var(--Brand-Neutral-Deep_gray, #6a6967);
    text-align: center;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.6;
    padding-bottom: 40rem;
}



.match-list {
    margin-top: 7rem;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 20rem;
    height: 340rem;
    overflow-y: auto;
    padding-left: 16rem;
    padding-bottom: 10rem;
}

.match-header {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--Text-Primary_White, #fff);
    font-size: 16rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.25;
    height: 56rem;
    text-align: center;
    background: url("../assets/image/activity/barac2526/match-title.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
    transform: translateY(-16rem);
    padding: 0 80rem;
}

.match-header span {
    font-weight: 400;
}

.match-item {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.match-item-label {
    padding: 0 20rem;
    min-width: 185rem;
    border-left: 4px solid #a52933;
    transform: skewX(-27.5deg);
    background-color: #f7f7f7;
    color: var(--Text-Primary, #000);
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    margin-right: 10rem;
}

.match-item-label-text {
    display: inline-block;
    transform: skewX(27.5deg);
}

.match-item-value {
    border: 1px solid #a52933;
    transform: skewX(-27.5deg);
    padding: 0 20rem;
    min-width: 290rem;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2;
    margin-right: 24rem;
}

.match-item-value-text {
    display: flex;
    justify-content: flex-start;
    padding-left: 10rem;
    align-items: baseline;
    gap: 15rem;
    transform: skewX(27.5deg);
    text-align: center;
}

.match-vs {
    font-size: 12rem;
    color: #3e77ea;
}

/* 整个滚动条 */
.match-list::-webkit-scrollbar {
    width: 6rem;
    /* 竖向滚动条宽度 */
    height: 6rem;
    /* 横向滚动条高度 */
}

/* 滚动条轨道 */
.match-list::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 3rem;
}

/* 滚动条滑块 */
.match-list::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3rem;
}

/* 滚动条滑块悬停状态 */
.match-list::-webkit-scrollbar-thumb:hover {
    background: #f2f2f2;
}


.section6-content {
    margin-top: 90rem;
    display: flex;
    justify-content: space-between;
}

.section6-content-left {
    flex-shrink: 0;
    position: relative;
    width: 540rem;
    overflow: hidden;
}

.section6-content-right {
    position: relative;
    width: 550rem;
    flex-shrink: 0;
}

.attraction-imgs {}

.attraction-img {
    position: absolute;
    width: 456rem;
    /* height: 100%; */
    object-fit: cover;
    border-radius: 12rem;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2); */
}

/* 默认布局：第0张最左（当前），第1张中间，第2张最右（最小） */
.attraction-img:nth-child(1) {
    /* 当前卡 */
    z-index: 3;
    transform: translateX(0) scale(1);
    left: 0;
    filter: brightness(1);
}

.attraction-img:nth-child(2) {
    /* 中间卡 */
    z-index: 2;
    transform: translateX(70rem) scale(0.9);
    left: 0;
    filter: brightness(0.7);
}

.attraction-img:nth-child(3) {
    /* 最后卡 */
    z-index: 1;
    transform: translateX(140rem) scale(0.8);
    left: 0;
    filter: brightness(0.5);
}

.section6-item-title {
    color: var(--Text-Primary, #000);
    font-size: 32rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.25;
}

.section6-item-intro {
    margin-top: 32rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    /* 150% */
}

.attraction-list-btns {
    margin-top: 80rem;
    display: flex;
    gap: 24rem;
}

.attraction-list-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 62rem;
    height: 62rem;
    border-radius: 50%;
    background-color: #e7e7e7;
    transition: background 0.3s;
}

.attraction-list-btn:hover {
    background-color: #f2f2f2;
}

.attraction-list-btn .icon-wrapper1 {
    font-size: 30rem;
}

.attraction-list-prev-btn .icon-wrapper1 {
    transform: rotate(180deg);
}

.section2-tips {
    margin-top: 48rem;
    display: flex;
    justify-content: center;
    text-align: center;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    /* 150% */
}

.section3-tips {
    margin-top: 48rem;
    display: flex;
    justify-content: center;
    text-align: center;
    color: var(--Text-Quaternary_White, rgba(255, 255, 255, 0.32));
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    /* 150% */
}

@media (max-width: 1440px) {

    .section2-inner,
    .section3-inner,
    .section4-inner,
    .section5-inner,
    .section6-inner {
        padding: 120rem 120rem;
    }

    .section1 {
        background-position: -480rem 0;
    }

    .section1-inner {
        padding: 0 710rem 0 100rem;
    }

    .section1 h1 {
        margin-top: 50rem;
        color: var(--ebc--, #fff);
        font-size: 54rem;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        max-width: 1000rem;
    }

    .en h1 {
        font-size: 48rem;
    }

    .jp h1 {
        font-size: 38rem;
    }

    .th h1 {
        font-size: 44rem;
    }

    .ru h1 {
        font-size: 42rem;
    }

    .pt h1 {
        font-size: 38rem;
    }

    .id h1 {
        font-size: 44rem;
    }

    .es h1 {
        font-size: 34rem;
    }
}

@media (max-width: 996px) {


    .section1 {
        height: auto;
        background: url("../assets/image/activity/barac2526/bg_m.jpg");
        background-repeat: no-repeat;
        background-size: 100% auto;
    background-position: bottom;
    }

    .section1-inner {
        justify-content: flex-start;
        align-items: center;
        padding: 89rem 24rem 80rem;
    }

    .ar .section1 {
        padding: 89rem 30rem 0;
    }

    .section1 h1 {
        line-height: 1.2;
        // margin-top: 160rem;
        font-size: 62rem;
        text-align: center;
    }

    // .section1 h1 {
    //     line-height: 1.2;
    //     margin-top: 128rem;
    //     font-size: 80rem;
    //     text-align: center;
    // }

    .en h1 {
        font-size: 58rem;
    }

    .jp h1 {
        font-size: 42rem;
    }

    .th h1 {
        font-size: 50rem;
    }

    .ru h1 {
        font-size: 48rem;
    }

    .pt h1 {
        font-size: 43rem;
        margin-top: 160rem;
    }

    .mn h1 {
        font-size: 52rem;
    }

    .kr h1 {
        margin-top: 160rem;
        font-size: 68rem;
    }

    .es h1 {
        margin-top: 180rem;
        font-size: 38rem;
    }

    .id h1 {
        margin-top: 150rem;
        font-size: 50rem;
    }

    .section1 .title-intro {
        margin-top: 800rem;
        text-align: center;
        font-size: 28rem;
        line-height: 1.25;
    }

    .section1 .ebc-btn-large {
        margin-top: 40rem;
    }

    .section2-inner,
    .section3-inner,
    .section4-inner,
    .section5-inner,
    .section6-inner {
        padding: 160rem 30rem;
    }

    .title-intro {
        font-size: 24rem;
    }

    .section2 {
        background: url("../assets/image/activity/barac2526/bg2_m.jpg");
        background-repeat: no-repeat;
        background-size: cover;
    }

    .section2 .vector-box,
    .section3 .vector-box {
        font-size: 32rem;
        margin-bottom: 32rem;
    }

    .section2-content {
        padding: 80rem 20rem;
    }

    .section2 .link-box {
        margin-top: 8rem;
    }

    .section2 .show-link {
        font-size: 24rem;
    }

    .section2 .show-link::after {
        font-size: 24rem;
    }

    .section3 {
        background: url("../assets/image/activity/barac2526/bg3_m.jpg");
        background-repeat: no-repeat;
        background-size: cover;
    }

    .section3-content {
        flex-direction: column;
        width: 100%;
        height: 1200rem;
        background: url("../assets/image/activity/barac2526/section3_card_m.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .section3-content-card {
        width: 100%;
        height: calc(50% - 12rem);
    }

    .section3-content-table {
        width: 100%;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 162rem 162rem;
        gap: 24rem;
    }

    .en .section3-content-table {
        grid-template-rows: 174rem 174rem;
    }

    .section3-content-card {
        padding: 0 24rem !important;
    }

    .section3-content .good-name {
        font-size: 24rem;
    }

    .section3-number {
        margin-top: 32rem;
    }

    .section3-number-label {
        gap: 16rem;
        font-size: 32rem;
    }

    .section4-content {
        flex-direction: column;
        gap: 16rem;
    }

    .section4-card {
        width: 100%;
        height: 294rem;
        flex-direction: column;
        justify-content: center;
        gap: 32rem;
    }

    .section4-img {
        width: 130rem;
        height: 130rem;
    }

    .en .section4-card p,
    .section4-card p {
        font-size: 36rem;
        text-align: center;
    }

    .en .section4-card {
        height: auto;
        min-height: 32rem;
        padding-top: 20rem;
        padding-bottom: 20rem;
    }

    .section4 .icon-right-round {
        font-size: 32rem;
        transform: rotate(90deg);
    }

    .button-box {
        margin-top: 80rem;
    }

    .section4 .ebc-btn-large {
        width: auto;
    }

    .step1,
    .step2,
    .step3 {
        background-size: 160rem auto;
    }

    .section5-tips {
        margin-top: 80rem;
        font-size: 24rem;
    }

    .match-list {
        height: 610rem;
        padding-left: 28rem;
        gap: 28rem;
    }

    .match-header {
        height: 84rem;
        transform: translateY(-24rem);
        font-size: 26rem;
        padding: 0 130rem;
    }

    .match-tips {
        font-size: 24rem;
        padding: 0 40rem 40rem;
    }

    .match-item-label {
        font-size: 24rem;
    }

    .match-item-value {
        font-size: 28rem;
        margin-right: 35rem;
        min-width: 420rem;
    }

    .match-vs {
        font-size: 24rem;
    }



    .match-item-value-text {
        padding-left: 20rem;
    }

    .section6-content {
        flex-direction: column;
    }

    .section6-content-left {
        margin-top: 80rem;
        width: 100%;
        order: 2;
    }

    .section6-content-right {
        padding-top: 34rem;
        height: 332rem;
        order: 1;
        width: 100%;
    }

    .section6-item-title {
        text-align: center;
    }

    .section6-item-intro {
        font-size: 24rem;
        text-align: center;
    }

    .attraction-img {
        width: 60%;
    }

    .attraction-img:nth-child(1) {
        /* 当前卡 */
        z-index: 1;
        transform: translateX(0) scale(1);
        left: 0;
        filter: brightness(0.7);
    }

    .attraction-img:nth-child(2) {
        /* 中间卡 */
        z-index: 2;
        transform: translateX(33%) scale(1.25);
        left: 0;
        filter: brightness(1);
    }

    .attraction-img:nth-child(3) {
        /* 最后卡 */
        z-index: 1;
        transform: translateX(67%) scale(1);
        left: 0;
        filter: brightness(0.7);
    }

    .attraction-list-btns {
        display: none !important;
    }

    .section2-tips,
    .section3-tips {
        font-size: 24rem;
    }
}
</style>

<style lang="scss">
@import url("../assets/css/rem_new.css");

.barca2526 {
    .section1 h1 span {
        color: #ff4b4e;
    }

    .h1-br {
        display: none;
    }

    .level-box {
        display: flex;
        flex-direction: column;
        gap: 30rem;
        align-items: center;
    }

    .level-box .icon-right-round {
        font-size: 28rem;
        color: rgba(0, 0, 0, 0.24);
    }

    .ar .level-box .icon-right-round {
        transform: rotate(180deg);
    }

    .level-title {
        color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
        text-align: center;
        font-size: 16rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.5;
        /* 150% */
    }

    .level-content {
        display: flex;
        align-items: center;
        gap: 80rem;
    }

    .level-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        max-width: 230rem;
        flex-shrink: 0;
    }

    .level-img {
        width: 210rem;
        height: 210rem;
    }

    .level-tips {
        color: #000;
        text-align: center;
        font-size: 20rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.3;
    }

    .good-list-swiper-pagination {
        margin-top: 68rem;
        display: flex;
    }

    .good-index-item {
        position: relative;
        flex-shrink: 0;
        margin: 0 !important;
        width: 16.6% !important;
        height: auto !important;
        opacity: 1 !important;
        background: none;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .good-index-item::after {
        position: absolute;
        left: 50%;
        top: 12px;
        content: "";
        width: 100%;
        height: 4px;
        background: #e4e4e4;
        z-index: -1;
    }

    .ar .good-index-item::after {
        left: unset;
        right: 50%;
    }

    .good-index-item:last-child:after {
        content: none;
    }

    .good-index-box {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 28px;
        height: 28px;
        border: 1px solid #d6d6d6;
        background: #fff;
        border-radius: 50%;
        transition: all 0.3s;
    }

    .good-index-box .good-index-inner {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        line-height: 1;
        width: 20px;
        height: 20px;
        background: #d6d6d6;
        border-radius: 50%;
        color: #f0f0f0;
        transition: all 0.3s;
    }

    .swiper-pagination-bullet-active .good-index-box {
        transform: scale(1.1);
        border-color: #5d2333;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .swiper-pagination-bullet-active .good-index-inner {
        background: #5d2333;
    }

    .Lv-label {
        margin-top: 10rem;
        color: var(--Text-Primary, #000);
        text-align: center;
        font-size: 20rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.3;
    }

    .Lv-value {
        margin-top: 10rem;
        color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
        text-align: center;
        font-size: 14rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.5;
    }

    .ebc-dialog {
        padding: 0;
    }

    .ebc-dialog .ebc-dialog-close-btn {
        right: 20rem;
        top: 28rem;
        font-size: 20rem;
    }



    .ebc-dialog-content {
        height: auto;
        padding: 0 20rem;
        overflow: visible;
    }
}

@media (max-width: 1440px) {
    .h1-br {
        display: block;
    }
}

@media (max-width: 996px) {
    .barca2526 {
        .h1-br {
            display: block;
        }

        .level-item:first-child {
            width: 100%;
            max-width: unset;
        }

        .level-title {
            font-size: 24rem;
        }

        .level-content {
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            gap: 48rem 96rem;
            min-height: 520rem;
        }

        .good-index-box {
            width: 20px;
            height: 20px;
        }

        .good-index-box .good-index-inner {
            font-size: 14px;
            width: 14px;
            height: 14px;
        }

        .good-index-item::after {
            top: 8px;
        }

        .level-tips {
            font-size: 32rem;
        }

        .Lv-label {
            margin-top: 24rem;
            font-size: 24rem;
        }

        .Lv-value {
            display: none;
        }

        .ebc-dialog .ebc-dialog-close-btn {
            font-size: 32rem;
            right: 32rem;
            top: 32rem;
        }


    }
}
</style>